const topics = [
  { name: '热血漫画', count: '12.8万', icon: 'ri-fire-line', color: 'primary' },
  { name: '恋爱漫画', count: '10.5万', icon: 'ri-heart-line', color: 'accent' },
  { name: '奇幻漫画', count: '9.2万', icon: 'ri-magic-line', color: 'secondary' },
  { name: '悬疑漫画', count: '7.6万', icon: 'ri-search-eye-line', color: 'primary' },
  { name: '搞笑漫画', count: '8.9万', icon: 'ri-emotion-laugh-line', color: 'accent' },
  { name: '都市漫画', count: '6.3万', icon: 'ri-building-line', color: 'secondary' },
  { name: '古风漫画', count: '5.7万', icon: 'ri-ancient-pavilion-line', color: 'primary' },
  { name: '科幻漫画', count: '4.8万', icon: 'ri-rocket-line', color: 'accent' },
  { name: '校园漫画', count: '7.1万', icon: 'ri-school-line', color: 'secondary' },
];

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: { bg: 'bg-primary-50 hover:bg-primary-100', text: 'text-primary-600', iconBg: 'bg-primary-100' },
  accent: { bg: 'bg-accent-50 hover:bg-accent-100', text: 'text-accent-600', iconBg: 'bg-accent-100' },
  secondary: { bg: 'bg-secondary-50 hover:bg-secondary-100', text: 'text-secondary-600', iconBg: 'bg-secondary-100' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门题材</h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">探索最受欢迎的漫画题材分类，找到属于你的<strong>免费漫画资源</strong></p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {topics.map((topic) => {
            const c = colorMap[topic.color];
            return (
              <a
                key={topic.name}
                href="#index"
                className={`flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl border border-background-200/60 transition-colors cursor-pointer ${c.bg}`}
              >
                <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center ${c.iconBg}`}>
                  <i className={`${topic.icon} text-lg md:text-xl ${c.text}`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.name}</span>
                <span className="text-xs text-foreground-400">{topic.count} 作品</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}